import React from 'react';
import { Shield, Lock, BookOpen, Users, FileCheck, Settings } from 'lucide-react';

export default function IpProtection() {
  return (
    <div className="max-w-4xl mx-auto py-8 px-4">
      <div className="rounded-lg shadow-md p-8" style={{ backgroundColor: 'var(--color-background)' }}>
        <h1 className="text-3xl font-bold mb-6" style={{ color: 'var(--color-font)' }}>How Your Ideas Are Protected</h1>
        <p className="text-lg mb-8" style={{ color: 'var(--color-font)' }}>
          At StoryMuse.io, we understand how important your ideas are—they're your passion, your creativity, 
          and your intellectual property. That's why we've taken every step to ensure your work is safe and respected.
        </p>

        <h2 className="text-2xl font-bold mb-6" style={{ color: 'var(--color-font)' }}>Here's How We Keep Your Ideas Safe:</h2>
        
        <div className="grid gap-6 md:grid-cols-2">
          <div className="p-6 rounded-lg" style={{ backgroundColor: 'var(--color-accent3)', opacity: 0.9 }}>
            <div className="flex items-center gap-3 mb-4">
              <FileCheck className="w-6 h-6" style={{ color: 'var(--color-accent1)' }} />
              <h3 className="font-semibold text-lg" style={{ color: 'var(--color-font)' }}>Your Intellectual Property Rights</h3>
            </div>
            <p style={{ color: 'var(--color-font)' }}>
              Any idea you post remains 100% yours. By sharing on StoryMuse.io, you are not transferring 
              or relinquishing any ownership rights to your creative concepts.
            </p>
          </div>

          <div className="p-6 rounded-lg" style={{ backgroundColor: 'var(--color-accent3)', opacity: 0.9 }}>
            <div className="flex items-center gap-3 mb-4">
              <Settings className="w-6 h-6" style={{ color: 'var(--color-accent1)' }} />
              <h3 className="font-semibold text-lg" style={{ color: 'var(--color-font)' }}>Privacy Controls</h3>
            </div>
            <p style={{ color: 'var(--color-font)' }}>
              You decide how much of your idea to share. Whether it's a simple pitch or a detailed synopsis, 
              you're in control of the level of detail you provide.
            </p>
          </div>

          <div className="p-6 rounded-lg" style={{ backgroundColor: 'var(--color-accent3)', opacity: 0.9 }}>
            <div className="flex items-center gap-3 mb-4">
              <Shield className="w-6 h-6" style={{ color: 'var(--color-accent1)' }} />
              <h3 className="font-semibold text-lg" style={{ color: 'var(--color-font)' }}>Terms of Use That Protect Creators</h3>
            </div>
            <p style={{ color: 'var(--color-font)' }}>
              Our platform's Terms of Service are designed with creators in mind. We explicitly prohibit 
              the unauthorized use, replication, or distribution of any content shared on StoryMuse.io.
            </p>
          </div>

          <div className="p-6 rounded-lg" style={{ backgroundColor: 'var(--color-accent3)', opacity: 0.9 }}>
            <div className="flex items-center gap-3 mb-4">
              <Lock className="w-6 h-6" style={{ color: 'var(--color-accent1)' }} />
              <h3 className="font-semibold text-lg" style={{ color: 'var(--color-font)' }}>Secure Environment</h3>
            </div>
            <p style={{ color: 'var(--color-font)' }}>
              We use state-of-the-art encryption and secure systems to ensure your account and posted 
              ideas are protected from unauthorized access.
            </p>
          </div>

          <div className="p-6 rounded-lg" style={{ backgroundColor: 'var(--color-accent3)', opacity: 0.9 }}>
            <div className="flex items-center gap-3 mb-4">
              <Users className="w-6 h-6" style={{ color: 'var(--color-accent1)' }} />
              <h3 className="font-semibold text-lg" style={{ color: 'var(--color-font)' }}>Community Guidelines</h3>
            </div>
            <p style={{ color: 'var(--color-font)' }}>
              Our community thrives on respect and collaboration. We actively monitor and enforce 
              anti-plagiarism policies and provide mechanisms to report any misuse.
            </p>
          </div>

          <div className="p-6 rounded-lg" style={{ backgroundColor: 'var(--color-accent3)', opacity: 0.9 }}>
            <div className="flex items-center gap-3 mb-4">
              <BookOpen className="w-6 h-6" style={{ color: 'var(--color-accent1)' }} />
              <h3 className="font-semibold text-lg" style={{ color: 'var(--color-font)' }}>Exclusive Visibility Options</h3>
            </div>
            <p style={{ color: 'var(--color-font)' }}>
              Need feedback from a smaller group? Use our visibility controls to share your ideas 
              only with trusted readers or a private audience.
            </p>
          </div>
        </div>

        <div className="mt-12 p-8 rounded-lg" style={{ backgroundColor: 'var(--color-accent1)' }}>
          <h2 className="text-2xl font-bold mb-4" style={{ color: 'var(--color-background)' }}>Our Commitment to Writers</h2>
          <p className="text-lg" style={{ color: 'var(--color-background)' }}>
            At StoryMuse.io, we're not just a platform—we're your partner in creativity. We believe in 
            empowering writers, and that starts with protecting your work. Join a community where your 
            imagination is celebrated, not compromised.
          </p>
        </div>
      </div>
    </div>
  );
}